var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Menu } from 'modules/v2';
import { StyledDiv } from './styled';
export function NestedBreadcrumb(props) {
    const { children, as, onClick } = props, restProps = __rest(props, ["children", "as", "onClick"]);
    return (<Menu.Item onClick={onClick} render={<StyledDiv as={as} {...restProps}/>}>
      {children}
    </Menu.Item>);
}
